"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var endpoint_1 = require("./endpoint");
function cleanQuery(query) {
    return lodash_1.transform(query, function (result, value, key) {
        if (lodash_1.isNil(value) === false) {
            result[key] = value;
        }
        return result;
    });
}
var Hertha = /** @class */ (function (_super) {
    __extends(Hertha, _super);
    function Hertha(stage) {
        return _super.call(this, stage, 'hertha') || this;
    }
    Hertha.prototype.sessionToken = function (bookingNumber, firstName, lastName, salesChannel, agencyID, userID, userName) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, query;
            return __generator(this, function (_a) {
                params = {
                    bookingNumber: bookingNumber,
                };
                url = '/booking/{bookingNumber}/sessions';
                query = {
                    lastName: lastName,
                    firstName: firstName,
                    salesChannel: salesChannel,
                    agencyID: agencyID,
                    userID: userID,
                    userName: userName,
                };
                return [2 /*return*/, this.invokeNoCacheGET(params, url, query)];
            });
        });
    };
    Hertha.prototype.changeSessionContext = function (sessionID, agencyID, salesChannel, entryPoint, userID, userName) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = { sessionID: sessionID };
                pathTemplate = '/session/{sessionID}/sessionValues';
                body = {
                    agencyID: agencyID,
                    salesChannel: salesChannel,
                    entryPoint: entryPoint,
                    userID: userID,
                    userName: userName,
                };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Hertha.prototype.productsForSession = function (sessionID, productType, shipId) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, query;
            return __generator(this, function (_a) {
                params = {};
                url = '/products';
                query = {
                    sessionID: sessionID,
                    productType: productType,
                    shipID: shipId,
                };
                return [2 /*return*/, this.invokeShortGET(params, url, cleanQuery(query))];
            });
        });
    };
    /** @deprecated */
    Hertha.prototype.productsForSessionCount = function (sessionID, productType) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, query;
            return __generator(this, function (_a) {
                params = {};
                url = '/products';
                query = {
                    sessionID: sessionID,
                    count: true,
                    productType: productType,
                };
                return [2 /*return*/, this.invokeNoCacheGET(params, url, cleanQuery(query))];
            });
        });
    };
    Hertha.prototype.cachedProducts = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, query;
            return __generator(this, function (_a) {
                params = {};
                url = '/productsCached';
                query = {
                    shipIds: getCommaSaperatedString(opts.shipIds),
                    portIds: getCommaSaperatedString(opts.portIds),
                    cruiseId: opts.cruiseId,
                    productType: opts.productType,
                    categoryCode: opts.categoryCode,
                    limit: opts.limit,
                };
                return [2 /*return*/, this.invokePermanentGET(params, url, cleanQuery(query))];
            });
        });
    };
    // TODO: Write tests for cachedProduct!!
    Hertha.prototype.cachedProduct = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, query;
            return __generator(this, function (_a) {
                params = {};
                url = '/productsCached/forProduct';
                query = { productIds: getCommaSaperatedString(opts.productIds) };
                return [2 /*return*/, this.invokePermanentGET(params, url, cleanQuery(query))];
            });
        });
    };
    Hertha.prototype.cachedProductsCount = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var params, url, query;
            return __generator(this, function (_a) {
                params = {};
                url = '/productsCached';
                query = {
                    shipIds: getCommaSaperatedString(opts.shipIds),
                    portIds: getCommaSaperatedString(opts.portIds),
                    productType: opts.productType,
                    categoryCode: opts.categoryCode,
                    count: true,
                };
                return [2 /*return*/, this.invokePermanentGET(params, url, cleanQuery(query))];
            });
        });
    };
    // ---------------------------------------------------------------------------
    Hertha.prototype.timeSlots = function (sessionID, productID, date) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    productID: productID,
                };
                pathTemplate = '/products/{productID}/timeslots';
                query = date ? { sessionID: sessionID, date: date } : { sessionID: sessionID };
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, query)];
            });
        });
    };
    Hertha.prototype.extendedDetailsForProduct = function (sessionID, productData) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = {};
                pathTemplate = '/details';
                body = {
                    sessionID: sessionID,
                    productData: productData,
                };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Hertha.prototype.articles = function (sessionID, shopItem) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    sessionID: sessionID,
                    shopItem: shopItem,
                };
                pathTemplate = '/carts/{sessionID}/articlesdetailed';
                query = {};
                if (shopItem) {
                    lodash_1.extend(query, { shopItem: shopItem });
                }
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, query)];
            });
        });
    };
    /** @deprecated */
    Hertha.prototype.articlesForSession = function (sessionID, scope) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { sessionID: sessionID };
                pathTemplate = '/carts/{sessionID}/articles';
                query = {};
                if (scope) {
                    query = { scope: scope };
                }
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, query)];
            });
        });
    };
    /** @deprecated */
    Hertha.prototype.extendedDetailsForArticle = function (sessionID, articleID) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    sessionID: sessionID,
                    articleID: articleID,
                };
                pathTemplate = '/carts/{sessionID}/articles/{articleID}';
                query = {};
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, query)];
            });
        });
    };
    Hertha.prototype.addArticle = function (sessionID, productCodeOrProducts, timeSlot, paxInfos) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = { sessionID: sessionID };
                pathTemplate = '/carts/{sessionID}/articles';
                body = {
                    productCode: typeof productCodeOrProducts === 'string'
                        ? productCodeOrProducts
                        : undefined,
                    timeSlot: timeSlot,
                    paxInfos: paxInfos,
                    products: Array.isArray(productCodeOrProducts)
                        ? productCodeOrProducts
                        : undefined,
                };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Hertha.prototype.changeArticle = function (sessionID, articles) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = { sessionID: sessionID };
                pathTemplate = '/carts/{sessionID}/articles';
                body = {
                    changedArticles: articles,
                };
                return [2 /*return*/, this.invokePUT(params, pathTemplate, body)];
            });
        });
    };
    Hertha.prototype.removeArticle = function (sessionID, articleID) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    sessionID: sessionID,
                    articleID: articleID,
                };
                query = {};
                if (typeof articleID === 'string') {
                    pathTemplate = '/carts/{sessionID}/articles/{articleID}';
                }
                if (articleID instanceof Array) {
                    pathTemplate = '/carts/{sessionID}/articles';
                    query.articleIDs = lodash_1.join(articleID);
                }
                return [2 /*return*/, this.invokeDELETE(params, pathTemplate, query)];
            });
        });
    };
    Hertha.prototype.paymentOptions = function (sessionID, articleIds) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { sessionID: sessionID };
                pathTemplate = '/carts/{sessionID}/payments';
                query = {
                    articleIds: articleIds,
                };
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, cleanQuery(query))];
            });
        });
    };
    Hertha.prototype.validateIban = function (sessionID, iban) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = { sessionID: sessionID };
                pathTemplate = '/carts/{sessionID}/validateIban';
                query = {
                    iban: iban,
                };
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, cleanQuery(query))];
            });
        });
    };
    Hertha.prototype.checkout = function (sessionID, checkoutData, payer, shopitems) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = {
                    sessionID: sessionID,
                };
                pathTemplate = '/carts/{sessionID}/checkout';
                body = {
                    checkoutData: checkoutData,
                    payer: payer,
                    shopitems: shopitems,
                };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Hertha.prototype.cancelCheckout = function (sessionID, articleIds, payerData, gtcAccepted, dataUsageAccepted) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, body;
            return __generator(this, function (_a) {
                params = {
                    sessionID: sessionID,
                };
                pathTemplate = '/carts/{sessionID}/cancelcheckout';
                body = {
                    articleIds: articleIds,
                    payerData: payerData,
                    gtcAccepted: gtcAccepted,
                    dataUsageAccepted: dataUsageAccepted,
                };
                return [2 /*return*/, this.invokePOST(params, pathTemplate, body)];
            });
        });
    };
    Hertha.prototype.documentInfos = function (sessionID) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    sessionID: sessionID,
                };
                pathTemplate = '/carts/{sessionID}/checkout/documents';
                query = {};
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, query)];
            });
        });
    };
    Hertha.prototype.document = function (sessionID, documentID, documentType) {
        return __awaiter(this, void 0, void 0, function () {
            var params, pathTemplate, query;
            return __generator(this, function (_a) {
                params = {
                    sessionID: sessionID,
                    documentID: documentID,
                    documentType: documentType,
                };
                pathTemplate = '/carts/{sessionID}/checkout/documents/{documentType}/{documentID}';
                query = {};
                return [2 /*return*/, this.invokeNoCacheGET(params, pathTemplate, query)];
            });
        });
    };
    return Hertha;
}(endpoint_1.Endpoint));
exports.default = Hertha;
function getCommaSaperatedString(ids) {
    if (lodash_1.isNil(ids)) {
        return undefined;
    }
    if (lodash_1.isArray(ids)) {
        return ids.join(',');
    }
    return ids;
}
//# sourceMappingURL=hertha.js.map